import React, { useLayoutEffect, useState } from "react";
import { Block, Icon, Layer, useViewportSizeName } from "thorium-ui";
import { Spinner } from "../common/Spinner";

export const StatsBadge = (props) => {
   const viewportSizeName = useViewportSizeName();
   const [logo, setLogo] = useState(null);

   useLayoutEffect(() => {
      const lazyLoadImage = async () => {
         const logo = await import(`../../assets/svg/${props.name}Logo.svg`)
            .then((data) => {
               return data.default;
            })
            .catch((e) => console.error(e));
         setLogo(logo);
      };
      lazyLoadImage();
   }, [props.name]);

   return (
      <Block title={props.title} xs={12} sm={12} md={6} lg={3} xl={3}>
         <Layer
            className="stats-badge mx-0"
            vertical={!["xs", "sm"].includes(viewportSizeName)}
         >
            <Block
               xs={5}
               sm={5}
               md={12}
               lg={12}
               xl={12}
               justify="center"
               className="a-center stats-badge-icon px-0"
            >
               <Icon
                  src={`${logo}#${props.name}`}
                  height={75}
                  width={75}
                  fill={props.logoColor}
               />
            </Block>
            <Block
               xs={7}
               sm={7}
               md={12}
               lg={12}
               xl={12}
               className={`stats-badge-details ${viewportSizeName}`}
            >
               {!props.data && (
                  <Block>
                     <Spinner />
                  </Block>
               )}
               {props.data && (
                  <p>
                     <strong className="stats-badge-data">{props.data}</strong>
                     <br />
                     <span className="stats-badge-subtitle">{props.unit}</span>
                  </p>
               )}
            </Block>
         </Layer>
      </Block>
   );
};

export default StatsBadge;
